export default __webpack_public_path__ + "static/media/customer.c87d440a.svg";